import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const copd: AnswerPathTreeNode = {
  path: 'copd',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredCopdDetails }],
};
